export enum ERoleSystem {
  ADMIN = 'admin', // Администратор
  GUEST = 'guest', // Неавторизованный пользователь
  USER = 'user', // Пользователь
}
